import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';
import { PayButton } from '../PaymentInputs/PayButton';
import { shouldHideEmail } from '@/utils/conditionalRendering';
import { Email } from '../Common/Email';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useCallback, useContext, useMemo, useState } from 'react';
import { isEmailValid } from '@/utils/email';
import { PaymentMethodEnum } from '@/types/common';

export const StripeDirectPayForm = ({ paymentMethod }: { paymentMethod: PaymentMethodEnum }) => {
  const {
    actions: { runPayment },
    customer,
    featureFlags,
    template,
  } = useContext(CheckoutContext);

  const [isCustomerAddressAndZipValid, setIsCustomerAddressAndZipValid] = useState(false);
  const handleAddressAndZipValidate = useCallback((isValid: boolean) => {
    setIsCustomerAddressAndZipValid(isValid);
  }, []);

  const isPayButtonDisabled = useMemo(() => {
    return !isCustomerAddressAndZipValid || !isEmailValid(customer?.email);
  }, [isCustomerAddressAndZipValid, customer?.email]);

  const handlePayment = async () => {
    await runPayment({ type: paymentMethod });
  };
  return (
    <div className="flex flex-col gap-4">
      {!shouldHideEmail(featureFlags, customer, template.features) && <Email />}
      <InputTaxComponent onValidate={handleAddressAndZipValidate} />

      <PayButton onClick={handlePayment} isDisabled={isPayButtonDisabled} />
    </div>
  );
};
